module.exports = __webpack_public_path__ + "static/media/Portrait-10185.d60991c4.jpg";